<template>
  <div>
    <!-- 抽屉组件 -->
    <el-drawer
      class="drawer"
      title="请选择任务对比"
      append-to-body
      :visible.sync="drawerFlag"
      :before-close="handleClose">
      <div class="container">
        <el-row class="screen" :span="24" style="margin-bottom:20px">
          <el-col :span="8">
            <el-select
             @clear="searchTaskList"
            @change="searchTaskList"
            v-model="taskQuery.taskStatus" placeholder="请选择任务状态" class="sel" style="width: 100%" filterable clearable>
               <el-option label="关闭" :value="1"/>
                <el-option label="开启" :value="2"/>
            </el-select>
          </el-col>
          <el-col :span="16">
            <el-input placeholder="请输入任务名称" v-model.trim="taskQuery.taskName" @keyup.13.native="drawerHandlerKeyUp" class="inp" style="width: 100%">
              <el-button slot="append" icon="el-icon-search" @click="getTaskList"></el-button>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-tag
            class="tag"
            v-for="taskId in Object.keys(addTask)"
            :key="taskId"
            @close="closeTag(taskId)"
            closable
            type="">
            {{addTask[taskId].taskName}}
          </el-tag>
        </el-row>
         <el-table
          ref="multipleTable"
          :data="tableOptions"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          >
          <el-table-column
            prop="taskName"
            label="任务名称"
            >
            <!-- <template slot-scope="scope">{{ scope.row.date }}</template> -->
          </el-table-column>
          <el-table-column
            label="状态"
            show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.taskStatus === 1?'关闭':'开启'}}
            </template>
          </el-table-column>
           <el-table-column
            label="操作"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <!-- {{scope.row.type === 1?'关闭':'开启'}} -->
              <el-button
                :disabled="scope.row.groupField === 'device_name'"
                size="mini"
                @click="add(scope.row)">添加对比</el-button>
            </template>
          </el-table-column>

        </el-table>

            <Paging
              :total="total"
              pagingStatus=""
              @changePage="currentPageChange"/>

      </div>
      <div class="drawer-footer">
        <div class="drawer-btn">
          <el-button
          type="primary"
          @click="confirmAdd"
          >
            确认
          </el-button>
          <el-button
          @click="close"
          >
            关闭
          </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { taskList } from '@/api/dataStatistics'
import Paging from '@/components/paging'
import { eventBus } from '@/utils/eventBus'
export default {
  props: {
    drawerFlag: {
      type: Boolean
    },
    compareTask: {
      type: Object
    },
    productKey: {
      type: String
    }
  },
  components: {
    Paging
  },
  data () {
    return {
      total: 0,
      listQuery: { // 筛选任务列表
        page: 1,
        limit: 10
      },
      tableOptions: [],
      taskQuery: { // 筛选任务列表
        taskStatus: 2,
        taskName: ''
      },
      addTask: Object.assign({}, this.compareTask)
    }
  },
  async created () {
    this.getTaskList()
  },
  methods: {
    confirmAdd () {
      this.$emit('confirmAdd', this.addTask)
      eventBus.$emit('getCompareChartData', this.addTask)
    },
    closeTag (taskId) {
      this.$delete(this.addTask, taskId)
    },
    add (row) {
      if (Object.keys(this.addTask).length < 5) {
        this.$set(this.addTask, row.taskId, row)
      } else {
        this.$message({
          type: 'error',
          message: '对比任务数量不能超过5个'
        })
      }
    },
    currentPageChange (listQuery) {
      Object.assign(this.listQuery, {
        page: listQuery.page,
        limit: listQuery.limit
      })
      this.getTaskList()
    },
    // 条件筛选任务
    searchTaskList () {
      this.listQuery.page = 1
      this.getTaskList()// 先获取任务列表
    },
    getTaskList () {
      const params = {
        productKey: this.productKey,
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        taskStatus: this.taskQuery.taskStatus,
        taskName: this.taskQuery.taskName,
        isPaging: true
      }
      taskList(params).then(res => {
        // 循环遍历属性为响应式的
        // this.forEachObject(this.tableOptions, res.data.data)
        res = res.data
        const list = res.data.list ? res.data.list : []
        this.tableOptions.splice(0, this.tableOptions.length, ...list)
        if (res.data.recordCount) {
          this.total = res.data.recordCount
        } else {
          this.total = 0
        }
        console.log('任务列表:,', list)
      })
    },
    // 关闭抽屉
    handleClose (done) {
      this.$confirm('确认关闭？', '提示', {
        closeOnClickModal: false
      })
        .then(_ => {
          this.$emit('closeDrawer')
        })
        .catch(_ => {})
        .finally(_ => {
        })
    },
    close () {
      this.handleClose()
    },
    // 抽屉搜索功能
    drawerHandlerKeyUp (e) {
      if (e.keyCode === 13) {
        this.getTaskList()
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .drawer{
      /deep/ .el-drawer__header{
        line-height: 60px !important;
        font-size: 18px !important;
        height: 60px !important;
        border-bottom: 1px solid #efefef !important;
        padding: 0 24px !important;
        margin-bottom: 0 !important;
      }
      /deep/ .el-drawer__body{
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: space-between;
        .container{
          padding: 16px 24px 0 24px !important;
          border-top: 1px solid #ececec;
          .screen{
            display: flex;
            /deep/ .el-input{
              margin-left: 0;
              width: 90%;
            }
          }
          /deep/ .el-table::before{
            background: white;
          }
          /deep/ .el-table th>.cell:first-child{
            padding: 0 14px
          }

        }
        .drawer-footer{
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #ececec;
          margin-top: 10px;
          padding: 0 24px ;
          height:64px;
          i{
            color: #409eff;
            font-style: normal;
          }
        }
      }
      /deep/ :focus {
        outline: 0;
      }
      .pagination-container{
        margin-top: 10px;
      }
      .tag{
        margin-right: 5px;
        margin-bottom: 5px;
      }
    }
</style>
